import { gql } from 'apollo-angular';
import { Page } from '../../entities/page/page';
import { User } from '../../entities/user/user';


export const USERS_QUERY = gql`
query usersQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String, $email: String, $firstName: String, $lastName: String, $enabled: Boolean, $licenceType: [LicenceType])
{
  users: getUsersPaged(
    userFilter: {email: $email, firstname: $firstName, lastname: $lastName, enabled: $enabled,  licenceType:$licenceType}
    sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
    pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection}
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          firstName
          lastName
          enabled
          userName
          email
          licenceType
      }
  }
}
`;

export interface UsersQueryResponse {
  users: Page<User>;
  loading: boolean;
}
